//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { UndercoverParkingLargeSVG } from './svg'

interface UndercoverParkingLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const UndercoverParkingLargeIcon: React.FC<UndercoverParkingLargeIconProps> = forwardRef<
  UndercoverParkingLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={UndercoverParkingLargeSVG}
    sx={sx}
  />
))
